import { Injectable } from '@angular/core';
import { Configuration } from '../../config/config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
@Injectable()
export class AppServiceManager {
    private jsonHeaders: HttpHeaders;
    private actionUrl: string;
    constructor(private _http: HttpClient, private _configuration: Configuration, private route: Router) {
        this.actionUrl = _configuration.ServerWithApiUrl;
        this.jsonHeaders = new HttpHeaders();
        this.jsonHeaders.append('Content-Type', 'application/json');
        this.jsonHeaders.append('Accept', 'application/json');
        // this.jsonHeaders.append('Authorization', _configuration.serviceToken);
    }
    get(url: string): any {

        return this._http.get(this.actionUrl + url, { headers: this.jsonHeaders })
            .pipe(
                map((res: any) => {
                    try {
                        var serviceResponse = res;
                        return serviceResponse;
                    }
                    catch (exp) {
                        if (res.status == 200) {
                            console.log("Error");
                        } else {
                            console.log("Error");
                        }
                    }
                }),
                catchError((err, caught) => {
                    console.log(err, caught);
                    if (err.status == 401) {
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('currentRole');
                        localStorage.removeItem('token');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('currentCompany');
                        this.route.navigateByUrl('/login');
                    }
                    return throwError(err);
                })
            );
    }
    post(url: string, body: Object): any {

        return this._http.post(this.actionUrl + url, body, { headers: this.jsonHeaders })
            .pipe(
                map((res: any) => {
                    try {
                        var serviceResponse = res;
                        return serviceResponse;
                    }
                    catch (exp) {
                        if (res.status == 200) {
                            console.log("Error");
                        } else {
                            console.log("Error");
                        }

                    }
                }),
                catchError((err, caught) => {
                    console.log(err, caught);
                    if (err.status == 401) {
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('currentRole');
                        localStorage.removeItem('token');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('currentCompany');
                        this.route.navigateByUrl('login');
                    }
                    return throwError(err);
                })
            );
    }
    put(url: string, body: Object): any {

        return this._http.put(this.actionUrl + url, body, { headers: this.jsonHeaders })
            .pipe(
                map((res: any) => {
                    try {
                        var serviceResponse = res;
                        return serviceResponse;
                    }
                    catch (exp) {
                        if (res.status == 200) {
                            console.log("Error");
                        } else {
                            console.log("Error");
                        }

                    }
                }),
                catchError((err, caught) => {
                    console.log(err, caught);
                    if (err.status == 401) {
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('currentRole');
                        localStorage.removeItem('token');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('currentCompany');
                        this.route.navigateByUrl('login');
                    }
                    return throwError(err);
                })
            );

    }
    delete(url: string): any {

        return this._http.delete(this.actionUrl + url, { headers: this.jsonHeaders })
            .pipe(
                map((res: any) => {
                    try {
                        var serviceResponse = res;
                        return serviceResponse;
                    }
                    catch (exp) {
                        if (res.status == 200) {
                            console.log("Error");
                        } else {
                            console.log("Error");
                        }

                    }
                }),
                catchError((err, caught) => {
                    console.log(err, caught);
                    if (err.status == 401) {
                        localStorage.removeItem('currentUser');
                        localStorage.removeItem('currentRole');
                        localStorage.removeItem('token');
                        localStorage.removeItem('expiration');
                        localStorage.removeItem('currentCompany');
                        this.route.navigateByUrl('login');
                    }
                    return throwError(err);
                })
            );
    }

}